import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <Card className="p-8">
          <div className="prose max-w-none">
            <h2 className="text-xl font-bold mb-4">Data Collection</h2>
            <p className="text-gray-600 mb-6">
              Daily UAE Jobs collects personal information that you provide when registering, uploading CVs, or using our services. This includes your name, email address, and CV content.
            </p>
            
            <h2 className="text-xl font-bold mb-4">Data Usage</h2>
            <p className="text-gray-600 mb-6">
              We use your data to provide our CV analysis, interview preparation, and career services. Your CV data is processed by AI to generate personalized feedback.
            </p>
            
            <h2 className="text-xl font-bold mb-4">Data Protection</h2>
            <p className="text-gray-600 mb-6">
              We implement industry-standard security measures to protect your personal information. Your data is encrypted and stored securely.
            </p>
            
            <h2 className="text-xl font-bold mb-4">Contact</h2>
            <p className="text-gray-600">
              For privacy-related inquiries, contact us at privacy@dailyuaejobs.com
            </p>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
